import { Colors } from "src/styles/DesignSystem";
import styled from "styled-components";

export const AboutContainer = styled.section`
    width: 100%;
    overflow: hidden;

    padding: 2rem 5rem;
    position: relative;

    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    &>img{
        position: absolute;
        width: 75%;
        top: -10%;
        right: -10%;
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 100%;
        flex-direction: column-reverse;
        padding: 25% 1rem 1rem 1rem;
        margin: 2% 5%;
    }
`;

export const AboutImages = styled.aside`
    width: 65%;
    position: relative;
    display: flex;
    align-items: flex-start;

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 100%;
        margin: 5% 0;
        flex: 2;
    }
`;

export const MainImage = styled.figure`
    width: 50%;

    img{
        width: 100%;
        border-radius: 20px;
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 60%;
    }
`;

export const MiniImage = styled.img`
    width: 30%;
    border-radius: 20px;

    position: absolute;
    top: 0;
    right: 15%;

    &:nth-child(2){
        top: 0%;
    }

    &:nth-child(3){
        top: 35%;
        right: 25%;
    }

    &:nth-child(4){
        top: 70%;
        right: 18%;
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 40%;

        &:nth-child(2){
            right: -5%;
        }

        &:nth-child(3){
            right: 5%;
        }

        &:nth-child(4){
            right: -2%;
        }
    }
`;

export const AboutText = styled.aside`
    width: 35%;
    z-index: 99;
    margin-top: 5%;

    h2{
        font: 2rem / 1.2 "Titan One", arial, sans-serif;
        color: ${Colors.white};
    }

    p{
        margin: 1rem 0;
        font: 1rem / 1.2 "Varela Round", arial, sans-serif;
        color: ${Colors.white};
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 100%;
        margin: 5% 0;
        flex: 1;
    }
`;